<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn class="mx-2" icon text small :to="{ name: 'item-list', path: 'lista' }">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Novo item</span>
              <span v-else>Alterar item: {{codigo}} - {{descricao}}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="codigo"
              :error-messages="codigoErrors"
              :counter="20"
              label="Código"
              required
              @input="$v.codigo.$touch()"
              @blur="$v.codigo.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="codigo_barras"
              :error-messages="codigobarrasErrors"
              :counter="13"
              label="Código de Barras"
              @input="$v.codigo_barras.$touch()"
              @blur="$v.codigo_barras.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="peso_bruto"
              v-mask="'decimal3'"
              :error-messages="pesobrutoErrors"
              :counter="14"
              label="Peso Bruto"
              @input="$v.peso_bruto.$touch()"
              @blur="$v.peso_bruto.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="peso_liquido"
              v-mask="'decimal3'"
              :error-messages="pesoliquidoErrors"
              :counter="10"
              label="Peso Líquido"
              @input="$v.peso_liquido.$touch()"
              @blur="$v.peso_liquido.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="qtd_minima_estoque"
              v-mask="'decimal3'"
              :error-messages="qtdminimaestoqueErrors"
              :counter="10"
              label="Qtd Mínima Estoque"
              @input="$v.qtd_minima_estoque.$touch()"
              @blur="$v.qtd_minima_estoque.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="qtd_maxima_estoque"
              v-mask="'decimal3'"
              :error-messages="qtdmaximaestoqueErrors"
              :counter="10"
              label="Qtd Máxima Estoque"
              @input="$v.qtd_maxima_estoque.$touch()"
              @blur="$v.qtd_maxima_estoque.$touch()"
            ></v-text-field>
            <v-autocomplete
              v-model="ativo"
              :error-messages="ativoErrors"
              :items="ativos"
              item-text="descricao"
              item-value="codigo"
              hide-no-data
              label="Ativo"
            ></v-autocomplete>
            <v-autocomplete
              v-model="id_unidademedida"
              :error-messages="unidademedidaErrors"
              :loading="loading"
              :items="unidadesMedidas"
              item-text="descricao"
              item-value="id"
              hide-no-data
              label="Unidade Medida"
            ></v-autocomplete>
            <v-autocomplete
              v-model="id_grupoitem"
              :error-messages="grupoitemErrors"
              :loading="loading"
              :items="gruposItens"
              item-text="descricao"
              item-value="id"
              hide-no-data
              label="Grupo"
            ></v-autocomplete>
            <v-autocomplete
              v-model="id_subgrupoitem"
              :loading="loading"
              :items="subGruposItens"
              item-text="descricao"
              item-value="id"
              hide-no-data
              label="Sub-Grupo"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import { unmaskDecimal } from "../lib/masks";

export default {
  mixins: [validationMixin],

  validations: {
    descricao: { required, maxLength: maxLength(50) },
    codigo: { required, maxLength: maxLength(20) },
    codigo_barras: { maxLength: maxLength(13), numeric },
    peso_bruto: { maxLength: maxLength(14) },
    peso_liquido: { maxLength: maxLength(14) },
    qtd_minima_estoque: { maxLength: maxLength(14) },
    qtd_maxima_estoque: { maxLength: maxLength(14) },
    ativo: { required },
    id_unidademedida: { required },
    id_grupoitem: { required }
  },

  data() {
    return {
      id: "",
      codigo: "",
      descricao: "",
      id_unidademedida: "",
      codigo_barras: "",
      peso_bruto: "",
      peso_liquido: "",
      id_grupoitem: "",
      id_subgrupoitem: "",
      qtd_minima_estoque: "",
      qtd_maxima_estoque: "",
      ativo: "",
      tituloNovo: true,

      loading: false,
      ativos: [
        { codigo: "S", descricao: "Sim" },
        { codigo: "N", descricao: "Não" }
      ],
      unidadesMedidas: [],
      gruposItens: [],
      subGruposItens: [],
      search: null,
      select: null
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      return errors;
    },
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.maxLength && errors.push("Somente 20 caracteres.");
      !this.$v.codigo.required && errors.push("Código é Obrigatório.");
      return errors;
    },
    codigobarrasErrors() {
      const errors = [];
      if (!this.$v.codigo_barras.$dirty) return errors;
      !this.$v.codigo_barras.maxLength && errors.push("Somente 13 caracteres.");
      !this.$v.codigo_barras.numeric && errors.push("Somente número");
      return errors;
    },
    pesobrutoErrors() {
      const errors = [];
      if (!this.$v.peso_bruto.$dirty) return errors;
      !this.$v.peso_bruto.maxLength && errors.push("Somente 14 caracteres.");
      return errors;
    },
    pesoliquidoErrors() {
      const errors = [];
      if (!this.$v.peso_liquido.$dirty) return errors;
      !this.$v.peso_liquido.maxLength && errors.push("Somente 14 caracteres.");
      return errors;
    },
    qtdminimaestoqueErrors() {
      const errors = [];
      if (!this.$v.qtd_minima_estoque.$dirty) return errors;
      !this.$v.qtd_minima_estoque.maxLength &&
        errors.push("Somente 14 caracteres.");
      return errors;
    },
    qtdmaximaestoqueErrors() {
      const errors = [];
      if (!this.$v.qtd_maxima_estoque.$dirty) return errors;
      !this.$v.qtd_maxima_estoque.maxLength &&
        errors.push("Somente 14 caracteres.");
      return errors;
    },
    ativoErrors() {
      const errors = [];
      if (!this.$v.ativo.$dirty) return errors;
      !this.$v.ativo.required && errors.push("Campo é Obrigatório.");
      return errors;
    },
    unidademedidaErrors() {
      const errors = [];
      if (!this.$v.id_unidademedida.$dirty) return errors;
      !this.$v.id_unidademedida.required && errors.push("Campo é Obrigatório.");
      return errors;
    },
    grupoitemErrors() {
      const errors = [];
      if (!this.$v.id_grupoitem.$dirty) return errors;
      !this.$v.id_grupoitem.required && errors.push("Campo é Obrigatório.");
      return errors;
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;

        const success = await this.$store.dispatch("item/gravar", {
          id: this.id,
          codigo: this.codigo,
          descricao: this.descricao,
          id_unidademedida: this.id_unidademedida,
          codigo_barras: this.codigo_barras,
          peso_bruto: parseFloat(unmaskDecimal(this.peso_bruto, 3)),
          peso_liquido: parseFloat(unmaskDecimal(this.peso_liquido, 3)),
          id_grupoitem: this.id_grupoitem,
          id_subgrupoitem:
            this.id_subgrupoitem == "" ? null : this.id_subgrupoitem,
          qtd_minina_estoque: parseFloat(
            unmaskDecimal(this.qtd_minima_estoque, 3)
          ),
          qtd_maxima_estoque: parseFloat(
            unmaskDecimal(this.qtd_maxima_estoque, 3)
          ),
          ativo: this.ativo,
          qtd_estoque_atual: 0,
          data_cadastro: moment(),
          id_usuario_cadastro: this.$store.state.usuarios.usuarioAtivo.id
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "item-list" });
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de itens"
    });
    this.loading = true;
    this.id = "";
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch("item/carregarItem", id);
        this.codigo = response.data.codigo;
        this.descricao = response.data.descricao;
        this.codigo_barras = response.data.codigo_barras;
        this.peso_bruto = response.data.peso_bruto;
        this.peso_liquido = response.data.peso_liquido;
        this.qtd_minima_estoque = response.data.qtd_minina_estoque;
        this.qtd_maxima_estoque = response.data.qtd_maxima_estoque;
        this.ativo = response.data.ativo;
        this.id_unidademedida = response.data.id_unidademedida;
        this.id_grupoitem = response.data.id_grupoitem;
        this.id_subgrupoitem = response.data.id_subgrupoitem;
        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }

    const responseUnidadesMedidas = await this.$store.dispatch(
      "item/carregarUnidadesMedidas"
    );
    this.unidadesMedidas = responseUnidadesMedidas.data;

    const responseGruposItens = await this.$store.dispatch(
      "item/carregarGruposItens"
    );
    this.gruposItens = responseGruposItens.data;

    const responseSubGruposItens = await this.$store.dispatch(
      "item/carregarSubGruposItens"
    );
    this.subGruposItens = responseSubGruposItens.data;
    this.loading = false;
  }
};
</script>
